export function resetPayPassInput() {
  return {
    type: 'RESET_PAY_PASS_INPUT',
  };
}

export function checkPayPass(payPass) {
  return {
    type: 'CHECK_PAY_PASS',
    payPass,
  };
}

export function checkPayPassCompletion(data, error) {
  return {
    type: 'CHECK_PAY_PASS_COMPLETION',
    data,
    error,
  };
}

export function resetPayPass(payPass, mobile, verify) {
  return {
    type: 'RESET_PAY_PASS',
    payPass,
    mobile,
    verify,
  };
}

export function resetPayPassCompletion(data, error) {
  return {
    type: 'RESET_PAY_PASS_COMPLETION',
    data,
    error,
  };
}
